import React, { Component} from 'react';
import ReactDOM from 'react-dom';
import './Components.css';
import {Card, CardImg, CardText, CardBody, CardLink,CardTitle, CardSubtitle, CardHeader} from 'reactstrap';
import html from './pdf/HTML and CSS.pdf';
import js1 from './pdf/JavaScript and jQuery.pdf';
import js2 from './pdf/javascript the definitive guide.pdf';
import react1 from './pdf/learningreact.pdf';
import react2 from './pdf/The Road to learn React.pdf';


class Resources extends Component {
    constructor(props){
        super(props);
    }
    
    render() { 
        
        return ( 
            <section id="resources">
            <div className="resources">
                
                <div className="container-fluid">
                    <h1 className="text-center text-white pt-3">RESOURCES<hr/></h1>
                    <h3 className="text-center text-white py-3">These Resources will help you to learn Front-End Development.</h3>
                    <div className="row row-cols-1 row-cols-md-3">
                    
                        <div className="col mb-4">
                            <Card className="card shadow" style={{ width: '18rem', height:'20rem' }}>
                                <CardHeader><h4>Youtube Channels</h4></CardHeader>
                                <CardBody>
                                    <CardLink  href="https://www.youtube.com/TraversyMedia" target="_blank"><span className="link">Traversy Media</span></CardLink> <br/>
                                    <CardLink  href="https://www.youtube.com/channel/UC8butISFwT-Wl7EV0hUK0BQ" target="_blank"><span className="link">FreeCodeCamp</span></CardLink> <br/>
                                    <CardLink  href="https://www.youtube.com/user/programmingwithmosh" target="_blank"><span className="link">Programming with Mosh</span></CardLink> <br/>
                                    <CardLink  href="https://www.youtube.com/devEd" target="_blank"><span className="link">Dev Ed</span></CardLink> <br/>
                                    <CardLink  href="https://www.youtube.com/WebDevSimplified" target="_blank"><span className="link">Web Dev Simplified</span></CardLink> <br/>
                                    <CardLink  href="https://www.youtube.com/florinpop" target="_blank"><span className="link">Florin Pop</span></CardLink> <br/>
                                    <CardLink  href="https://www.youtube.com/user/DesignCourse" target="_blank"><span className="link">Design Course</span></CardLink> <br/>
                                    <CardLink  href="https://www.youtube.com/TylerPotts" target="_blank"><span className="link">Tyler Potts</span></CardLink> <br/>
                                    <CardLink  href="https://www.youtube.com/KevinPowell" target="_blank"><span className="link">Kevin Powell(CSS)</span></CardLink>
                                </CardBody>
                            </Card>
                        </div>

                        <div className="col mb-4">
                            <Card className="card shadow" style={{ width: '18rem', height:'20rem' }}>
                                <CardHeader><h4>Websites</h4></CardHeader>
                                <CardBody>
                                    <CardLink href="https://www.freecodecamp.org/" target="_blank"><span className="link">FreeCodeCamp</span></CardLink> <br/>
                                    <CardLink href="https://www.florin-pop.com/" target="_blank"><span className="link">Florin-POP</span></CardLink> <br/>
                                    <CardLink href="https://css-tricks.com/" target="_blank"><span className="link">CSS Tricks</span></CardLink> <br/>
                                    <CardLink href="https://flaviocopes.com/" target="_blank"><span className="link">Flavio Copes</span></CardLink> <br/>
                                    <CardLink href="https://javascript30.com/" target="_blank"><span className="link">JavaScript30</span></CardLink> <br/>
                                </CardBody>
                            </Card>
                        </div>

                        <div className="col mb-4">
                            <Card className="card shadow" style={{ width: '18rem', height:'20rem' }}>
                                <CardHeader><h4>Books</h4></CardHeader>
                                <CardBody>
                                    <CardLink href={html} target="_blank"><span className="link">HTML & CSS by Jon Ducket</span></CardLink> <br/>
                                    <CardLink href={js1} target="_blank"><span className="link">JavaScript & Jquery by Jon Ducket</span></CardLink> <br/>
                                    <CardLink href={js2} target="_blank"><span className="link">JavaScript: The Definitive Guide</span></CardLink> <br/>
                                    <CardLink href={react1} target="_blank"><span className="link">Learning React</span></CardLink> <br/>
                                    <CardLink href={react2} target="_blank"><span className="link">The Road to learn React</span></CardLink> <br/>
                                </CardBody>
                            </Card>
                        </div>

                        <div className="col mb-4">
                            <Card className="card shadow" style={{ width: '18rem', height:'20rem' }}>
                                <CardHeader><h4>Documentation</h4></CardHeader>  
                                <CardBody>
                                    <CardLink href="https://getbootstrap.com/docs/4.4/getting-started/introduction/" target="_blank"><span className="link">Bootstrap</span></CardLink> <br/>
                                    <CardLink href="https://developer.mozilla.org/en-US/docs/Learn" target="_blank"><span className="link">MDN WEb Docs</span></CardLink> <br/>
                                    <CardLink href="https://reactjs.org/docs/getting-started.html" target="_blank"><span className="link">Reactjs</span></CardLink> <br/>
                                    <CardLink href="" target="_blank"><span className="link"></span></CardLink>
                                    <CardLink href="" target="_blank"><span className="link"></span></CardLink>
                                </CardBody> 
                            </Card>
                        </div>
                        
                        <div className="col mb-4">
                            <Card className="card shadow" style={{ width: '18rem', height:'20rem' }}>
                                <CardHeader><h4>Free Courses</h4></CardHeader>  
                                <CardBody>
                                    <CardLink href="" target="_blank"><span className="link"></span></CardLink>
                                    <CardLink href="" target="_blank"><span className="link"></span></CardLink>
                                    <CardLink href="" target="_blank"><span className="link"></span></CardLink>
                                    <CardLink href="" target="_blank"><span className="link"></span></CardLink>
                                    <CardLink href="" target="_blank"><span className="link"></span></CardLink>
                                    <CardLink href="" target="_blank"><span className="link"></span></CardLink>
                                </CardBody> 
                            </Card>
                        </div>

                        <div className="col mb-4">
                            <Card className="card shadow" style={{ width: '18rem', height:'20rem' }}>
                                <CardHeader><h4>Podcasts</h4></CardHeader>   
                                <CardBody>
                                    <CardLink href="https://devchat.tv/js-jabber/" target="_blank"><span className="link">JavaScript Jabber</span></CardLink> <br/>
                                    <CardLink href="https://realtalkjavascript.simplecast.com/" target="_blank"><span className="link">Real Talk JavaScript</span></CardLink> <br/>
                                    <CardLink href="https://shoptalkshow.com/" target="_blank"><span className="link">Shoptalk Show</span></CardLink> <br/>
                                    <CardLink href="https://www.ladybug.dev/episodes/level-up-javascript" target="_blank"><span className="link">LadyBug</span></CardLink> <br/>
                                    <CardLink href="https://syntax.fm/" target="_blank"><span className="link">Syntax</span></CardLink> <br/>
                                </CardBody>
                            </Card>
                        </div>

                    </div>
                    

                </div>   
            </div>
            </section>
        );
        
    }
}
    
export default Resources;



//<-----------Youtube Channels---------------------->
/* <li><a href="https://www.youtube.com/TraversyMedia" target="_blank">Traversy Media</a></li>
<li><a href="https://www.youtube.com/channel/UC8butISFwT-Wl7EV0hUK0BQ" target="_blank">FreeCodeCamp</a></li>
<li><a href="https://www.youtube.com/devEd" target="_blank">Dev Ed</a></li>
<li><a href="https://www.youtube.com/WebDevSimplified" target="_blank">Web Dev Simplified</a></li>
<li><a href="https://www.youtube.com/florinpop" target="_blank">Florin Pop</a></li>
<li><a href="https://www.youtube.com/user/DesignCourse" target="_blank">Design Course</a></li>
<li><a href="https://www.youtube.com/TylerPotts" target="_blank">Tyler Potts</a></li>
<li><a href="https://www.youtube.com/KevinPowell" target="_blank">Kevin Powell(CSS)</a></li> */


//<---------------Websites---------->
/* <li><a href="https://www.freecodecamp.org/" target="_blank">FreeCodeCamp</a></li>
<li><a href="https://www.florin-pop.com/" target="_blank">Florin-POP</a></li>
<li><a href="https://css-tricks.com/" target="_blank">CSS Tricks</a></li>
<li><a href="https://flaviocopes.com/" target="_blank">Flavio Copes</a></li>
<li><a href="https://javascript30.com/" target="_blank">JavaScript30</a></li> */